import React from 'react';
import './Loading.css';

interface Props {
  label: string,
}

const Loading : React.FC<Props> = ({ label }) => {
  return (
    <p className="loading">
      Loading details for {label}
      <span className="dots">
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </span>
    </p>
  );
};

export default Loading;